var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrypto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_5634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6259 18.627 23.9981 11.9971 23.999C5.37206 23.999 -0.000959639 18.6259 5.14575e-07 11.999C-0.00191979 5.37216 5.3711 0 11.999 0C18.627 0 24 5.37312 24 12Z",
    fill: "#F2A900",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_236_5634)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_236_5634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7434 15.593V16.169C17.7434 16.7987 17.5141 17.4026 17.106 17.8479C16.6979 18.2932 16.1443 18.5434 15.5672 18.5434H8.60647C8.0298 18.5432 7.47675 18.2933 7.06882 17.8486C6.66088 17.4039 6.4314 16.8007 6.43079 16.1715V11.8062C6.43109 11.1768 6.66044 10.5733 7.06841 10.1283C7.47638 9.68333 8.02959 9.43327 8.60647 9.43311H15.5672C16.1443 9.43311 16.6979 9.68327 17.106 10.1286C17.5141 10.5738 17.7434 11.1778 17.7434 11.8075V12.6083",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5513 12.7458H17.9511C18.0338 12.7458 18.1158 12.7635 18.1922 12.7981C18.2687 12.8327 18.3381 12.8834 18.3966 12.9472C18.4551 13.0111 18.5015 13.0869 18.5331 13.1704C18.5647 13.2538 18.5809 13.3432 18.5809 13.4335V14.7169C18.5804 14.8988 18.5138 15.0731 18.3958 15.2015C18.2777 15.33 18.1178 15.4021 17.9511 15.4021H16.5513C16.2283 15.4021 15.9186 15.2622 15.6903 15.013C15.4619 14.7639 15.3336 14.426 15.3336 14.0736V14.0736C15.3336 13.8992 15.3651 13.7264 15.4263 13.5652C15.4875 13.404 15.5772 13.2576 15.6903 13.1342C15.8033 13.0109 15.9376 12.913 16.0853 12.8462C16.233 12.7795 16.3914 12.7451 16.5513 12.7451V12.7458Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43035 11.9173V9.83124C6.43035 9.83124 6.21615 8.27412 7.6346 7.71782C8.9442 7.20344 9.31089 7.03198 9.31089 7.03198",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47396 11.9777C6.21486 11.9777 6 11.767 6 11.5129V9.23825C6 8.31476 6.58771 7.47181 7.46612 7.14952L12.4837 5.29014C13.0019 5.10421 13.5833 5.17242 14.032 5.48231C14.4807 5.79221 14.7524 6.29423 14.7524 6.82725V9.18245C14.7524 9.43657 14.5376 9.6473 14.2785 9.6473C14.0194 9.6473 13.8045 9.43657 13.8045 9.18245V6.82725C13.8045 6.59173 13.6908 6.381 13.4949 6.24465C13.2926 6.10829 13.0462 6.07729 12.8187 6.15787L7.80105 8.01724C7.28285 8.20938 6.94792 8.68664 6.94792 9.23825V11.5129C6.94792 11.767 6.73306 11.9777 6.47396 11.9777Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 12.3577H12.778C12.778 12.3577 13.4921 12.3723 13.4921 13.1369C13.4921 13.9014 12.8519 13.9865 12.8519 13.9865H10.9672",
    stroke: "#292D32",
    strokeWidth: 0.395557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 15.6463H13.0958C13.0958 15.6463 13.8623 15.6317 13.8623 14.8677C13.8623 14.1038 13.1679 14.0181 13.1679 14.0181H10.9672",
    stroke: "#292D32",
    strokeWidth: 0.395557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9318 12.3577V15.6434",
    stroke: "#292D32",
    strokeWidth: 0.395557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.35 11.5625V12.362",
    stroke: "#292D32",
    strokeWidth: 0.395557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2404 11.5625V12.362",
    stroke: "#292D32",
    strokeWidth: 0.395557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3274 15.6738V16.474",
    stroke: "#292D32",
    strokeWidth: 0.395557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2178 15.6738V16.474",
    stroke: "#292D32",
    strokeWidth: 0.395557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_5634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_236_5634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_236_5634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 17,
    fill: "white",
    transform: "translate(6 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrypto);
export default __webpack_public_path__ + "static/media/crypto.455a6c4d5764b6c1846cf94d857cce86.svg";
export { ForwardRef as ReactComponent };